import React from "react";
import { HelpCircle } from "lucide-react";
import { useT } from "../lib/i18n";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";

const CONTENT = {
  nl: {
    tag: "Veelgestelde vragen",
    title: "Alles wat je wilt weten",
    items: [
      ["Hoe werkt de slimme matchscore?", "De matchscore vergelijkt jouw zoekprofiel (budget, locatie, oppervlakte, slaapkamers en meer) met elke woning en geeft een percentage van 0–100%. Hoe completer je profiel, hoe nauwkeuriger de match. Je ziet altijd wáárom een woning bij je past."],
      ["Is de scam-check betrouwbaar?", "De scam-check herkent bekende oplichtingssignalen zoals een verdacht lage prijs, vooruitbetaling zonder bezichtiging en buitenlandse rekeningnummers. Het is een krachtig hulpmiddel, maar geen garantie — bezichtig altijd fysiek vóórdat je betaalt."],
      ["Wat kost Premium?", "Je start volledig gratis. Premium kost € 9,95 per maand en geeft onbeperkte scam-checks, de reactiebrief-generator, foto-analyse en onbeperkte favorieten en alerts. Je kunt maandelijks opzeggen."],
      ["Hoe krijg ik woningalerts?", "Maak een account, stel een alert in met je stad, budget en wensen, en kies hoe vaak je bericht wilt (direct, dagelijks of wekelijks). Je ontvangt automatisch nieuwe passende woningen zodra ze verschijnen."],
      ["Is WoningAlert gratis te gebruiken?", "Ja. Woningen bekijken, je matchscore zien, alerts instellen en drie scam-checks per week zijn gratis. Upgrade alleen naar Premium als je meer wilt."],
    ],
  },
  en: {
    tag: "Frequently asked questions",
    title: "Everything you want to know",
    items: [
      ["How does the smart match score work?", "The match score compares your search profile (budget, location, size, bedrooms and more) with every home and gives a 0–100% score. The more complete your profile, the more accurate the match. You always see why a home fits you."],
      ["Is the scam check reliable?", "The scam check recognizes known scam signals such as a suspiciously low price, upfront payment without a viewing and foreign bank accounts. It's a powerful tool, but not a guarantee — always view a home physically before paying."],
      ["What does Premium cost?", "You start completely free. Premium is € 9.95 per month and gives unlimited scam checks, the response-letter generator, photo analysis and unlimited favorites and alerts. You can cancel monthly."],
      ["How do I get home alerts?", "Create an account, set up an alert with your city, budget and preferences, and choose how often you want to be notified (instant, daily or weekly). You'll automatically receive new matching homes as they appear."],
      ["Is WoningAlert free to use?", "Yes. Browsing homes, seeing your match score, setting alerts and three scam checks per week are free. Only upgrade to Premium if you want more."],
    ],
  },
};

export const FAQ = () => {
  const { lang } = useT();
  const c = CONTENT[lang] || CONTENT.nl;
  return (
    <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6" data-testid="faq">
      <div className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-brandblue-light px-3 py-1 text-sm font-semibold text-brandblue">
          <HelpCircle size={14} /> {c.tag}
        </span>
        <h2 className="mt-4 font-display text-3xl font-extrabold text-navy sm:text-4xl">{c.title}</h2>
      </div>
      <Accordion type="single" collapsible className="mt-10">
        {c.items.map(([q, a], i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-border">
            <AccordionTrigger className="text-left font-display text-base font-bold text-navy hover:no-underline">{q}</AccordionTrigger>
            <AccordionContent className="text-slate-600">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
